import React                 from "react";
import { RefluxComponent }   from "sp-react-commons";
import { last as _last, split as _split, merge as _merge } from "lodash";
import { GroupApi }          from "../../api/Api";
import { GroupRequestModal, Translation, UserStore }     from '../../../commons';


export default class LegacyGroupRequest extends RefluxComponent {

    constructor(props) {
        super(props);

        this.state = this.initialState();

        this.listenTo(UserStore, this.onRefreshUser);
    }

    initialState = () => ({
        canCreateRequest: false,
        alreadyCreatedRequest: false,
        showModal: false,
        legacyUserId: _last(_split(window.location.href, "/")) // Extract legacy id from latest part of the url
    });

    onRefreshUser = (data) => {
        if(data && data.user) {
            GroupApi.getGroupRequest(this.state.legacyUserId).then((groupRequest) => {
                this.setState({
                    canCreateRequest: true,
                    alreadyCreatedRequest: groupRequest
                });
            });
        }
    };

    onSubmit = (groupRequest) => {
        let request = _merge({legacyUserId: this.state.legacyUserId}, groupRequest);
        // Create group request and reload the page if everything is fine
        GroupApi.createGroupRequest(request).then(() => window.location.reload());
    };

    showModal = () => this.setState({showModal: true});
    hideModal = () => this.setState({showModal: false});

    renderRequestPanel = () => (
        <div className="info-container">
            <div className="info-container__close">x</div>
            <div className="info-container__content info-container__content--feature">
                <div className="pure-u-1 pure-u-md-20-24 pure-u-lg-20-24 pure-u-sm-24-24">
                    <div className="orange-bold">{Translation.translate("public.legacy-group-request.legacy-organisation")}</div><br/>{Translation.translate("public.legacy-group-request.group-request-message")}
                </div>
                <div className="pure-u-1 pure-u-md-4-24 pure-u-lg-4-24 pure-u-sm-24-24 text-center">
                    <button className="mywort-btn mywort-btn--orange" onClick={this.showModal}>{Translation.translate("public.legacy-group-request.want-create-group")}</button>
                </div>
            </div>
        </div>
    );

    renderAlreadyRequestedPanel = () => (
        <div className="info-container">
            <div className="info-container__close">x</div>
            <div className="info-container__content info-container__content--feature">
                <div className="pure-u-1 pure-u-md-20-24 pure-u-lg-20-24 pure-u-sm-24-24">
                    <span className="orange-bold">{Translation.translate("public.legacy-group-request.already-did-request")}</span>
                    <span>{Translation.translate("public.legacy-group-request.wait-for-validation")}</span>
                </div>
            </div>
        </div>
    );

    render = () => (
        <div>
            <GroupRequestModal show={this.state.showModal}
                               onHide={this.hideModal}
                               onSubmit={this.onSubmit}>
            </GroupRequestModal>
            { this.state.canCreateRequest ?
                this.state.alreadyCreatedRequest ? this.renderAlreadyRequestedPanel() : this.renderRequestPanel()
                : null
            }
        </div>
    );
}



// WEBPACK FOOTER //
// ./js/mywort/frontend/pages/legacyGroupRequest/LegacyGroupRequest.jsx